import { render, staticRenderFns } from "./AddAddons.vue?vue&type=template&id=7fccb940"
import script from "./AddAddons.vue?vue&type=script&lang=js"
export * from "./AddAddons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports